/**
 * Where the API lives, for a client that may not be served from it.
 *
 * Cards runs in two shapes. In development, and on the droplet, the Express
 * server serves this bundle and the API from one origin, so a relative path is
 * correct and this is the empty string. In production the client is on
 * Cloudflare Pages at cards.danvass.com while the API is on the droplet at
 * cards-api.danvass.com, and a relative `/api/...` would be answered by Pages'
 * SPA fallback with `index.html` — a 200 full of HTML, which is the most
 * confusing possible failure.
 *
 * One constant rather than two, because the REST calls and the websocket have
 * to agree: a session established against one origin and a socket opened
 * against another authenticates as nobody.
 *
 * Set `VITE_API_URL` at build time (it is baked into the bundle, so it is a
 * build input and not a runtime one). No trailing slash — paths arrive with a
 * leading one.
 */
const configured = import.meta.env.VITE_API_URL as string | undefined

export const API_BASE = (configured ?? (import.meta.env.DEV ? 'http://localhost:3002' : ''))
  .replace(/\/+$/, '')

/** Absolute when the API is elsewhere, unchanged when it is same-origin. */
export function apiUrl(path: string): string {
  if (!API_BASE) return path
  return path.startsWith('/') ? `${API_BASE}${path}` : `${API_BASE}/${path}`
}
